module.exports = __webpack_public_path__ + "img/bval.8b4cc3f1.svg";